import React from 'react';

import SetPageTitle from 'components/Portals/SetPageTitle';
import SetPageNavAction from 'components/Portals/SetPageNavAction';
import { Routes } from 'routing';

import Sales from './Sales';
import { useTranslation } from 'services/localization';

const Reports = () => {
	const { t } = useTranslation();
	return (
		<>
			<SetPageTitle priority={2} title={t('account.reports.pageTitle', 'Reports')} />
			<SetPageNavAction
				priority={2}
				backAction={{ to: Routes.ACCOUNT, title: t('account.pageTitle', 'Account') }}
			/>
			<Sales />
		</>
	);
};

export default Reports;
